/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FoldersControllerRemoveMutationResponse, FoldersControllerRemovePathParams, FoldersControllerRemoveQueryParams, FoldersControllerRemove401, FoldersControllerRemove403, FoldersControllerRemove404 } from "../../models/foldersController/FoldersControllerRemove";

function getFoldersControllerRemoveUrl(id: FoldersControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/folders/${id}` as const }  
  return res
}

/**
 * @summary Delete a folder
 * {@link /api/v1/folders/:id}
 */
export async function foldersControllerRemove(id: FoldersControllerRemovePathParams["id"], params?: FoldersControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FoldersControllerRemoveMutationResponse, ResponseErrorConfig<FoldersControllerRemove401 | FoldersControllerRemove403 | FoldersControllerRemove404>, unknown>({ method : "DELETE", url : getFoldersControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}